import { useQuery } from "@tanstack/react-query";
import { budgetCastPerformance } from "../api/budgetCastPerformance";
import { BudgetCastPerformance } from "../types";

export const useBudgetCostPerformance = () => {

    const { data, isLoading, isError, error, isSuccess } = useQuery({
        queryKey: ["budget-cost-performance"],
        queryFn: () => budgetCastPerformance.fetch(),
    });

    return {
        data: isSuccess ? data : {} as BudgetCastPerformance,
        isLoading,
        isError,
        error,
        isSuccess,
    }

};